












import Vue from "vue";

export default Vue.extend({
  name: "LayoutTeaserGrid",
  props: {
    columns: {
      type: Number,
      required: true
    }
  }
});
